/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as ActionTypes from './actionTypes';

const initialState = {
  planType: [],
  rebateProgramList: [],
  rebateProgramNameValue: '',
  selectedPlanType: '',
  rebateProgramValue: '',
  errors: [],

  rebateProgramName: '',
  searchResult: [],
  manufacturerList: [],
  manufacturer: '',
  manufacturerName: '',
  fromQuarter: '',
  toQuarter: '',
  isLoading: false,
  currentZeroResult: [],
  isAllManufacturersSelected: true,
  scrollDownManufacturers: true,
  isNDCChecked: false,
  selectedRowIndexValue: '',
  searchScreenVar: {
    rebateProgramValue: '',
    rebateProgramName: '',
    selectedPlanType: '',
    fromQuarter: '',
    toQuarter: '',
    isAllManufacturersSelected: true,
    scrollDownManufacturers: true,
    isNDCChecked: false,
  },
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.GET_PLAN_TYPE_DATA:
      return { ...state, planType: action.payload };
    // case ActionTypes.GET_REBATE_PROGRAM_CHIP_CSHCN_RATE_AUDIT:
    //   return { ...state, rebateProgramList: action.payload };
    case ActionTypes.SET_SELECTED_CHIP_CSHCN_RATE_AUDIT:
      return { ...state, ...action.payload };
    case ActionTypes.IS_LOADING_ADJUSTMENT_CHIP_CSHCN_RATES:
      return { ...state, isLoading: action.isLoading };
    case ActionTypes.GET_MANUFACTURER_LIST_CHIP_CSHCN_RATES:
      return { ...state, manufacturerList: action.manufacturerList };
    //Search Result API
    case ActionTypes.GET_CURRENT_ZERO_URA:
      return { ...state, currentZeroResult: action.currentZeroResult };
    case ActionTypes.REFRESH_CURRENT_ZERO_URA:
      return { ...state, searchScreenVar: initialState.searchScreenVar };
    case ActionTypes.REFRESH_CURRENT_ZERO_URA_DISPLAY:
      return { ...state, searchScreenVar: initialState.searchScreenVar };
    default:
      return state;
  }
};

export default reducer;
